import "./App.css";
import AppRoutes from "./routes/routes";

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
